var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"da915ed25117f9dc2e1d67429808eb08e25457e8"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["form-template-v1@claimscore-2f"]={id:"da915ed25117f9dc2e1d67429808eb08e25457e8"};
      